/**
 * Handles state for tracking what text should be displayed for captioning in
 * games and metagame.
 */

export const SET_VOICE_CAPTION = 'SET_VOICE_CAPTION';
export const SET_SFX_CAPTION = 'SET_SFX_CAPTION';

const initialState = {
  // These might update to arrays for more sophisticated captioning
  // someday, but for now, just single strings will work
  voice: '',
  sfx: '',
};

export default (state = initialState, { type, payload = {} }) => {
  switch (type) {
    case SET_VOICE_CAPTION:
      return { ...state, voice: payload };
    case SET_SFX_CAPTION:
      return { ...state, sfx: payload };
    default:
      return state;
  }
};

/**
 * Passes a string to captioning state. The string should exactly match the
 * voiced audio that it is associated with to provide captions for Deaf/HOH
 * students/teachers/caregivers.
 * @param {string} caption caption to be displayed with VO
 * @returns action for updating voice caption state
 */
export const setVoiceCaption = caption => ({
  type: SET_VOICE_CAPTION,
  payload: caption,
});

/**
 * Passes a string to captioning state. The string should exactly match the
 * SFX audio that it is associated with to provide captions for Deaf/HOH
 * students/teachers/caregivers.
 * @param {string} caption caption to be displayed with SFX
 * @returns action for updating SFX captioning state
 */
export const setSfxCaption = caption => ({
  type: SET_SFX_CAPTION,
  payload: caption,
});
